import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { openDemoMail, openPartnerMail } from '../lib/mailto';
export function FinalCTA() {
  return <section className="py-40 bg-zinc-950 relative overflow-hidden" data-id="element-66">
      {/* Ambient Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/5 rounded-full blur-[100px] pointer-events-none" data-id="element-67" />

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-68">
        <FadeIn data-id="element-69">
          <h2 className="text-5xl md:text-7xl font-display font-medium text-white mb-8 leading-tight" data-id="element-70">
            The Future of Property Inspections Is Already Here.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-71">
          <Button variant="primary" className="w-full sm:w-auto text-lg px-8 py-4" onClick={openDemoMail} data-id="element-72">
            Book a Demo
          </Button>
          <Button variant="secondary" className="w-full sm:w-auto text-lg px-8 py-4" onClick={openPartnerMail} data-id="element-73">
            Partner With Us
          </Button>
        </FadeIn>
      </div>
    </section>;
}